import StyledHeader from './styledheader.js';

export default function Header() {
	return <StyledHeader></StyledHeader>;
}
